export default "__VITE_PUBLIC_ASSET__3b430a87__"